<template>
    <v-container fluid class="align-center column" style="height: auto">
        <div class="path align-center">
            <div class="row screen-width" style="height: 24px; gap: 24px">
                <HomeOutline :size="24"></HomeOutline>
                <ChevronRight :size="24"></ChevronRight>
                <p>서비스 신청 및 조회</p>
                <ChevronRight :size="24"></ChevronRight>
                <p>AS 접수</p>
            </div>
        </div>

        <div id="product-select" class="column screen-width">
            <p style="font-size: 32px; font-weight: bold">1. 제품 정보</p>
            <div class="screen-width" style="height: 1px; background: gray"></div>
            <p style="font-size: 20px">• 제품 분류를 선택해주세요</p>
            <div class="row align-space-between" style="width: 100%">
                <div
                    id="product-list"
                    style="display: flex; align-content: center"
                >
                    <text-button
                        v-for="(category, index) in categoryList"
                        :key="index"
                        :textSize="14"
                        :buttonName="category"
                        :buttonStyle="{
                            border: '1px solid #CECECE',
                            background: 'white',
                        }"
                        @click="selectCategory(index)"
                        :clicked="index == selectedCategory"
                    ></text-button>
                </div>
            </div>
        </div>

        <div id="model-select" class="column screen-width">
            <p style="font-size: 20px">• 제품 모델을 선택해주세요.</p>
            <div class="row" style="width: 100%">
                <div
                    id="model-list"
                    style="display: flex; align-content: center"
                >
                    <p
                        v-for="(model, index) in product_model"
                        :key="index"
                        style="width: 45%; cursor: pointer"
                        :class="{ selected: selectedModel.id == model.id }"
                        @click="selectModel(model)"
                    >
                        • {{ model.sub_category }}
                    </p>
                </div>
            </div>
        </div>

        <div id="keyword-select" class="column screen-width">
            <p style="font-size: 28px; font-weight: bold">증상 분류</p>
            <p style="font-size: 20px">
                • 아래의 키워드 중 해당하는 증상을 선택해주세요.
            </p>
            <div class="row align-space-between" style="width: 100%">
                <div
                    id="keyword-list"
                    style="display: flex; align-content: center"
                >
                    <text-button
                        v-for="(keyword, index) in keyword_list"
                        :key="index"
                        :textSize="14"
                        :buttonName="keyword"
                        :buttonStyle="{
                            border: '1px solid #CECECE',
                            background: 'white',
                        }"
                        @click="selectKeyword(index)"
                        :clicked="index == selectedKeyword"
                    ></text-button>
                </div>
            </div>
        </div>

        <div id="issue" class="screen-width">
            <div>
                <div class="row">
                    <p style="font-size: 28px; font-weight: bold">상세증상</p>

                    <p style="font-size: 24px; color: gray; margin-left: 16px">
                        *
                    </p>
                </div>
                <textarea
                    v-model="detail_issue"
                    style="
                        width: 100%;
                        height: 200px;
                        border: 1px solid #a2a2a2;
                        margin-top: 20px;
                    "
                ></textarea>
            </div>
            <div class="row align-space-between">
                <div class="row">
                    <p style="font-size: 28px; font-weight: bold">구매처</p>
                    <p style="font-size: 24px; color: gray; margin-left: 16px">
                        *
                    </p>
                </div>
                <input
                    type="text"
                    v-model="buy_shop"
                    style="
                        width: 60%;
                        height: 56px;
                        border: 1px solid #a2a2a2;
                        padding: 12px;
                    "
                />
            </div>
            <div class="row align-space-between">
                <p style="font-size: 28px; font-weight: bold">구매 일자</p>

                <!-- <DatePicker
                    v-model="date"
                    locale="ko"
                    style="width: 50px; height: 50px"
                /> -->
                <DatePicker
                    style="width: 60%; height: 56px; background:white; color:black"
                    v-model="buy_date"
                    showIcon
                    dateFormat="yy-mm-dd"
                    :showOnFocus="false"
                    locale="jp-JP"
                />
            </div>
            <div class="row align-space-between">
                <p style="font-size: 28px; font-weight: bold">첨부 파일</p>
                <div class="row align-space-between" style="width: 60%">
                    <div
                        style="
                            width: 80%;
                            height: 56px;
                            border: 1px solid #a2a2a2;
                            padding: 12px;
                            display: flex;
                            align-items: center;
                        "
                    >
                        {{ fileName }}
                    </div>
                    <input
                        type="file"
                        id="upload-image"
                        hidden
                        @change="handleFileChange"
                    />
                    <label for="upload-image" style="width: 15%">
                        <div
                            class="align-center"
                            style="
                                width: 100%;
                                height: 56px;
                                border: 1px solid black;
                                border-radius: 20px;
                            "
                        >
                            추가
                        </div>
                    </label>
                </div>
            </div>
            <div class="row align-space-between">
                <p style="font-size: 28px; font-weight: bold">택배발송내역</p>
                <input
                    type="text"
                    style="
                        width: 60%;
                        height: 56px;
                        border: 1px solid #a2a2a2;
                        padding: 12px;
                    "
                />
            </div>
        </div>

        <div 
            class="screen-width" 
            style="
                height: 1px;
                background: gray;
                margin-top: 32px;
                margin-bottom: 80px;
            "
        ></div>

        <div id="customer" class="column screen-width">
             <div class="row align-space-between">
                <p style="font-size: 32px; font-weight: bold">2. 고객 정보</p>
                <div class="row" style="gap: 16px">
                    <text-button
                        :textSize="20"
                        :buttonName="'회원'"
                        :buttonStyle="{
                            width: '100px',
                            border: '1px solid #CECECE',
                            background: 'white',
                        }"
                        @click="goLogin"
                        :clicked="isAuth"
                    />
                    <text-button
                        :textSize="20"
                        :buttonName="'비회원'"
                        :buttonStyle="{
                            width: '100px',
                            border: '1px solid #CECECE',
                            background: 'white',
                        }"
                        @click="selectSubCategory(index)"
                        :disabled="isAuth"
                        :clicked="!isAuth"
                    />
                </div>
            </div>
            <div
                style="
                    width:100%;
                    height: 1px;
                    background: gray;
                    margin-top: 24px;
                "
            ></div>

            <div class="column" style="gap: 40px; margin-top: 48px">
                <div class="row align-space-between">
                    <div class="row">
                        <p style="font-size: 28px; font-weight: bold">
                            접수시 성명
                        </p>
                        <p
                            style="
                                font-size: 24px;
                                color: gray;
                                margin-left: 16px;
                            "
                        >
                            *
                        </p>
                    </div>
                    <input
                        type="text"
                        v-model="userName"
                        :disabled="isAuth"
                        style="
                            width: 60%;
                            height: 56px;
                            border-bottom: 1px solid #b4b4b4;
                            padding: 12px;
                        "
                        placeholder="접수시 성명을 입력해주세요."
                    />
                </div>
                <div class="row align-space-between">
                    <div class="row">
                        <p style="font-size: 28px; font-weight: bold">연락처</p>
                        <p
                            style="
                                font-size: 24px;
                                color: gray;
                                margin-left: 16px;
                            "
                        >
                            *
                        </p>
                    </div>
                    <input
                        type="text"
                        v-model="phoneNumber"
                        :disabled="isAuth"
                        style="
                            width: 60%;
                            height: 56px;
                            border-bottom: 1px solid #b4b4b4;
                            padding: 12px;
                        "
                        placeholder="'-'없이 휴대폰 번호를 입력해주세요"
                    />
                </div>
                <div>
                    <div class="row align-space-between">
                        <div class="row">
                            <p style="font-size: 28px; font-weight: bold">
                                주소
                            </p>
                            <p
                                style="
                                    font-size: 24px;
                                    color: gray;
                                    margin-left: 16px;
                                "
                            >
                                *
                            </p>
                        </div>

                        <div class="row align-space-between" style="width: 60%">
                            <input
                                type="text"
                                v-model="roadAddress"
                                style="
                                    width: 80%;
                                    height: 56px;
                                    border-bottom: 1px solid #b4b4b4;
                                    padding: 12px;
                                "
                                placeholder="주소를 검색하여 선택해주세요"
                            />
                            <button
                                class="align-center"
                                style="
                                    width: 12%;
                                    height: 56px;
                                    border: 1px solid black;
                                    border-radius: 25px;
                                    font-weight: bold;
                                "
                                @click="openPostCode"
                            >
                                검색
                            </button>
                        </div>
                    </div>
                    <div
                        class="row"
                        style="
                            justify-content: end;
                            align-items: center;
                            margin-top: 20px;
                        "
                    >
                        <input
                            type="text"
                            v-model="detailAddress"
                            style="
                                width: 60%;
                                height: 56px;
                                border-bottom: 1px solid #b4b4b4;
                                padding: 12px;
                            "
                            placeholder="상세 주소를 입력해주세요"
                        />
                    </div>
                </div>
                 <div class="row align-space-between" 
                        v-if="!isAuth">
                    <div class="row">
                        <p style="font-size: 28px; font-weight: bold">비밀번호(4자리)</p>
                        <p
                            style="
                                font-size: 24px;
                                color: gray;
                                margin-left: 16px;
                            "
                        >
                            *
                        </p>
                    </div>
                    <input
                        type="text"
                        v-model="pinNumber"
                        maxlength="4" 
                        style="
                            width: 60%;
                            height: 56px;
                            border-bottom: 1px solid #b4b4b4;
                            padding: 12px;
                        "
                        placeholder="숫자로 구성된 4자리 핀번호를 입력해주세요"
                        @input="validatePinNumber"
                    />
                </div>
                <div class="row align-space-between">
                    <p style="font-size: 28px; font-weight: bold">
                        개인정보 수집 • 이용 동의
                    </p>
                    <div class="row align-space-between" style="width: 40%">
                        <div class="row" style="gap: 40px">
                            <input
                                type="radio"
                                v-model="isAgree"
                                :value="true"
                                style="width: 40px"
                            />
                            <p style="font-size: 24px">동의</p>
                        </div>
                        <div class="row" style="gap: 40px">
                            <input
                                type="radio"
                                v-model="isAgree"
                                :value="false"
                                style="width: 40px"
                            />
                            <p style="font-size: 24px">동의 안함</p>
                        </div>
                    </div>
                </div>
                <div
                    style="
                        width: 100%;
                        height: auto;
                        border-radius: 20px;
                        border: 1px solid #d9d9d9;
                        padding: 32px;
                    "
                >
                    <p>고객님의 원활한 서비스 신청, 상담, 이력관리 등을 위해 개인정보 수집 및 이용 동의를 받고 있습니다.</p>
                    <br>
                    <p><strong>수집 항목:</strong> 성명, 전화번호, 주소</p>
                    <br>
                    <p><strong>수집 · 이용 목적:</strong> 제품 A/S 및 B/S, 상담, 제품 교환/환불, 고객만족도 조사</p>
                    <br>
                    <p><strong>보유·이용 기간:</strong> 5년 (수정되는 정보 포함)</p>
                    <p>(단, 상법 등 타 법령에 따른 정보는 해당 법령에서 정한 기간 보존)</p>

                    <p>※ 귀하께서는 본 동의를 거절하실 수 있으나, 미동의 시 해당 서비스 신청 및 이용에 제약이 있을 수 있습니다.</p>

                    <p>※ 개인정보 처리에 대한 상세한 사항은 화면 하단의 개인정보 처리방침을 참조하십시오.</p>
                    <br>
                    <p><strong>개인정보 입력 시 주의사항</strong></p>
                    <p>- 개인정보 보호를 위해 본인 외 타인의 정보(가족 포함)는 입력이 불가합니다.</p>
                    <p>- 잘못된 정보 제공으로 인한 책임은 정보 제공자에게 있으니 주의해 주시기 바랍니다.</p>
                    <p>- 본 화면에 입력하신 개인정보는 실제 서비스(상담)나 상품 주문 등을 신청해야 수집이 되며, 그 외에는 수집 또는 저장되지 않습니다.</p>
                </div>
            </div>
        </div>

        <button
            style="
                width: 640px;
                height: 100px;
                background: #27afe2;
                border-radius: 20px;
                color: white;
                font-size: 40px;
                font-weight: bold;
            "
            @click="submit"
        >
            접수 완료
        </button>
    </v-container>
</template>

<script>
import { ref, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import HomeOutline from "vue-material-design-icons/HomeOutline.vue";
import ChevronRight from "vue-material-design-icons/ChevronRight.vue";
import TextButton from "@/components/TextButton.vue";
import SearchBar from "@/components/SearchBar.vue";
import DownloadItem from "@/components/DownloadItem.vue";
import CustomPagination from "@/components/CustomPagination.vue";
import DatePicker from "primevue/datepicker";

export default {
    props: {
        category: {
            type: String,
            default: "GPS플로터",
        },
    },
    name: "problem-layout",
    components: {
        HomeOutline,
        ChevronRight,
        TextButton,
        SearchBar,
        DownloadItem,
        CustomPagination,
        DatePicker,
    },
    setup() {
        const store = useStore();
        const router = useRouter();
        const isAuth = ref(false);

        const categoryList = [
            "GPS플로터",
            "레이더",
            "무선/통신장비",
            "항해 안전장비",
            "항해 조타장비",
            "해상용 안테나/헤딩센서",
            "선박용 인산철배터리",
            "선박용 전기관련 제품",
            "부품 및 액세서리",
        ];

        const selectedCategory = ref(0);

        const product_model = computed(() => {
            return store.getters.getSubCategoryList;
        });

        const selectCategory = async (index) => {
            selectedCategory.value = index;
            await store.dispatch("getSubCategoryList", index);
            selectedModel.value = product_model.value[0];
        };

        const keyword_list = ref([
            "전원/배터리/충전",
            "전원/배터리/충전",
            "전원/배터리/충전",
            "전원/배터리/충전",
            "전원/배터리/충전",
            "전원/배터리/충전",
            "소리/진동",
            "소리/진동",
            "소리/진동",
            "소리/진동",
            "소리/진동",
        ]);

        const selectModel = async (model) => {
            selectedModel.value = model;
        };

        // 제품 정보 및 증상
        const selectedModel = ref(0);
        const selectedKeyword = ref(0);
        const selectKeyword = (index) => {
            selectedKeyword.value = index;
        };
        const detail_issue = ref("");
        const buy_shop = ref("");
        const buy_date = ref(null);
        const file = ref(null);
        const fileName = ref("");
        const uploadedFileName = ref("");
        const img_src = ref(null);

        // 사용자 정보
        const userId = ref(null);
        const userName = ref("");
        const phoneNumber = ref("");
        const roadAddress = ref("");
        const detailAddress = ref("");
        const pinNumber = ref("");
        const isAgree = ref(false);

        const handleFileChange = (e) => {
            file.value = e.target.files[0];
            fileName.value = file.value.name;
            store
                .dispatch("uploadFile", file.value)
                .then((res) => {
                    uploadedFileName.value = res.data.filename;
                })
                .catch((err) => {
                    console.error("Error:", err);
                });
        };


        const goLogin = () => {
            if (!isAuth.value) {
                router.push({ path: "/login" });
            }
        };

        // 모든 필드가 입력되었는지 확인
        const isAccess = computed(() => {
            return (
                detail_issue.value &&
                buy_shop.value &&
                phoneNumber.value &&
                phoneNumber.value.length >= 10 &&
                userName.value &&
                roadAddress.value &&
                detailAddress.value &&
                (isAuth.value || pinNumber.value) && 
                isAgree.value
            );
        });


        onMounted(async () => {
            await store.dispatch("getSubCategoryList", 0);
            try {
                const userProfile = await store.dispatch("getUserProfile");
                userId.value = userProfile.id;
                userName.value = userProfile.name;
                phoneNumber.value = userProfile.phone_number;
                if (userProfile.address.split(":").length == 2) {
                    roadAddress.value = userProfile.address.split(":")[0];
                    detailAddress.value = userProfile.address.split(":")[1];
                }
                isAuth.value = true;
            } catch (err) {
                console.log(err);
                isAuth.value = false;
            }

            selectedModel.value = product_model.value[0];
        });

        const userProfile = computed(() => {
            return store.getters.getUserProfile;
        });

        const openPostCode = () => {
            new window.daum.Postcode({
                oncomplete: (data) => {
                    roadAddress.value = data.roadAddress;
                },
            }).open();
        };

        const validatePinNumber = (event) => {
            let value = event.target.value;
            // 숫자가 아닌 문자 제거 & 최대 4자리 제한
            value = value.replace(/[^0-9]/g, "").slice(0, 4);
            pinNumber.value = value;
        };

        const submit = async () => {
            if (!isAccess.value) {
                alert("입력되지 않은 정보가 있습니다.");
                return;
            }

            const afterservice = {
                categoryId: selectedModel.value.id,
                defect_type: selectedKeyword.value,
                detail_issue: detail_issue.value,
                buy_shop: buy_shop.value,
                buy_date: buy_date.value,
                filename: uploadedFileName.value,
                user_name: userName.value,
                phone_number: phoneNumber.value,
                address: roadAddress.value + " " + detailAddress.value,
                pin: pinNumber.value,
                isAgree: isAgree.value,
                userId: userId.value,
            };

            await store.dispatch("addAfterservice", afterservice);
            router.replace({ path: "/service/check" });
            alert("서비스 신청이 접수되었습니다.");
        };

        return {
            selectCategory,
            selectedCategory,
            selectModel,
            selectedModel,
            keyword_list,
            selectedKeyword,
            selectKeyword,
            detail_issue,
            buy_date,
            handleFileChange,
            fileName,
            img_src,
            buy_shop,
            isAccess,
            isAgree,
            categoryList,
            product_model,
            userProfile,
            userName,
            phoneNumber,
            roadAddress,
            detailAddress,
            openPostCode,
            submit,
            isAuth,
            goLogin,
            validatePinNumber,
            pinNumber
        };
    },
};
</script>

<style scoped>
/* 화면 너비가 601px에서 900px 사이인 경우 */
@media (min-height: 601px) and (max-height: 850px) {
    .sensor-title {
        font-size: 0.675rem;
        padding: 2px 15px;
    }

    .sensor-value {
        padding: 5px 15px;
        font-size: 1rem;
    }
}

.selected {
    color: #00a7e7;
    font-weight: bold;
}

#product-select {
    padding: 40px 0px;
    gap: 24px;
}

#product-list {
    width: 100%;
    height: auto;
    background: #f4f4f4;
    border-radius: 10px;
    border: 1px solid #d9d9d9;
    padding: 30px;
    gap: 16px;
    flex-wrap: wrap;
}

#model-select {
    padding: 40px 0px;
    gap: 24px;
}

#model-list {
    width: 100%;
    height: auto;
    padding: 0px 30px;
    gap: 16px;
    flex-wrap: wrap; /* 이 설정이 요소들을 자동으로 줄 바꿈하게 합니다 */
}

#keyword-select {
    padding: 40px 0px;
    gap: 24px;
}

#keyword-list {
    width: 100%;
    height: auto;
    background: #f4f4f4;
    border-radius: 10px;
    border: 1px solid #d9d9d9;
    padding: 30px;
    gap: 16px;
    flex-wrap: wrap; /* 이 설정이 요소들을 자동으로 줄 바꿈하게 합니다 */
}
#issue {
    padding: 32px 0px;
    display: flex;
    flex-direction: column;
    gap: 40px;
}

#detail-issue {
    width: 100%;
    margin-top: 18px;
}

#customer {
    padding: 40px 0px;
}

textarea {
    padding: 10px;
    resize: none;
    border: none;
}
textarea:focus {
    outline: none !important;
}
input:focus {
    outline: none !important;
}

.p-datepicker.p-inputtext:enabled:focus {
    border-color: black !important;
}

.p-datepicker /deep/ .p-inputtext:enabled:focus {
    height: 56px; /* 예시: 높이 변경 */
    border: 1px solid rgb(162, 162, 162); /* 예시: 테두리 색상 변경 */
    outline: none;
}
.post-box {
    z-index: 100;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
}
</style>
